import { WifiOff } from "lucide-react";

export function OfflinePage() {
  return (
    <div className="flex h-screen w-screen flex-col items-center justify-center bg-slate-50 p-6">
      <div className="text-center">
        <div className="mx-auto mb-6 flex h-20 w-20 items-center justify-center rounded-2xl bg-gradient-to-br from-red-100 to-orange-100 shadow-soft">
          <WifiOff className="h-10 w-10 text-red-600" />
        </div>
        <h1 className="text-4xl font-bold text-slate-900">
          You Are Currently Offline
        </h1>
        <p className="mt-4 max-w-md text-lg text-slate-600">
          It looks like there's a problem with your network connection. Please
          check your internet and try again.
        </p>
        <button
          onClick={() => window.location.reload()}
          className="mt-8 rounded-lg bg-gradient-primary px-8 py-3 text-base font-semibold text-white shadow-lg transition-transform hover:scale-105"
        >
          Retry Connection
        </button>
      </div>
    </div>
  );
}
